// extracted by mini-css-extract-plugin
export default {"text":"styles_text__EDVvU","header":"styles_header__jbP-G","subHeader":"styles_subHeader__RTe2i","name":"styles_name__V5BJ4"};